import Image from "next/legacy/image";

import * as S from "./MktLandingPageBrandsOrganism.style";
import { brands } from "src/models/landing/brands/brands.model";

export default function MktLandingPageBrandsOrganism() {
  return (
    <S.Wrapper>
      <S.Title>
        <>
          가장 빠른 성장을 가능하게 하는
          <br />
          팀스파르타만의 교육 노하우
        </>
      </S.Title>
      <S.Brands>
        {brands.map(({ title, subtitle, logo, logoName }) => (
          <S.Brand key={logoName}>
            <S.BrandInfo>
              <S.BrandName>{title}</S.BrandName>
              <S.BrandDesc>{subtitle}</S.BrandDesc>
            </S.BrandInfo>
            <S.BrandLogo logoName={logoName}>
              <Image src={logo} quality={100} loading="lazy" alt={logoName} />
            </S.BrandLogo>
          </S.Brand>
        ))}
      </S.Brands>
      <S.Desc>
        2019년, 오프라인 강의로 시작한 팀스파르타의 코딩 교육은 어느덧 누적
        수강생 43만명,
        <br />
        개발자 취업 2,000여 명이라는 큰일을 만들어 내고 있습니다.
        <br /> 교육이 교육으로 끝나지 않도록, 수료를 넘어 취업, 커리어 성장까지
        함께 하겠습니다.
      </S.Desc>
    </S.Wrapper>
  );
}
